/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MoveFolderItemDtoFromJSON, MoveFolderItemDtoToJSON, } from './MoveFolderItemDto';
/**
 * Check if a given object implements the MoveFolderDto interface.
 */
export function instanceOfMoveFolderDto(value) {
    if (!('folders' in value) || value['folders'] === undefined)
        return false;
    if (!('newParentId' in value) || value['newParentId'] === undefined)
        return false;
    if (!('index' in value) || value['index'] === undefined)
        return false;
    return true;
}
export function MoveFolderDtoFromJSON(json) {
    return MoveFolderDtoFromJSONTyped(json, false);
}
export function MoveFolderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'folders': (json['folders'].map(MoveFolderItemDtoFromJSON)),
        'newParentId': json['newParentId'],
        'index': json['index'],
    };
}
export function MoveFolderDtoToJSON(json) {
    return MoveFolderDtoToJSONTyped(json, false);
}
export function MoveFolderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'folders': (value['folders'].map(MoveFolderItemDtoToJSON)),
        'newParentId': value['newParentId'],
        'index': value['index'],
    };
}
